<div class="card shadow-sm-darker">
  <p class="card-header mb-0 text-inherit">
    <span class="font-weight-600">{{media.title}} </span><br>
    Storage Used: <span class="font-weight-600">{{formattedSize(media.size)}}</span><br>
    Uploaded: <span class="font-weight-600">{{formattedDate(media.uploaddate)}}</span><br>
  </p>
  <div class="card-body">
    <div class="media m-auto" [ngClass]="{'audio-iframe-style': media.type.startsWith('audio')}" >
      <!-- <div class="media"> -->
      <app-module-media-iframe *ngIf="media.processed" [media]="media"></app-module-media-iframe>
      <div *ngIf="!media.processed && media.userisadmin" class="text-center"
        [ngClass]="{'errorprocessing': media.errorprocessing, 'media-processing-div': !media.errorprocessing}">
        <!-- <div *ngIf="!media.errorprocessing">The audio/video file is being processed. This could take anywhere from 2 minutes to 4 hours depending on the length of the file and the current load. You will receive an email when processing is complete. If you have waited for more than 4 hours, please contact support@impata.com</div> -->
        <p *ngIf="!media.errorprocessing" class="text-inherit">The audio/video file is being processed. This could take
          a while. You will receive an email when processing is complete.</p>
          
        <p *ngIf="media.errorprocessing && !media.processed" class="text-inherit">There was an error processing the audio/video file</p>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex">
      <button class="btn" *ngIf="media.errorprocessing && !media.processed" (click)="retryMediaProcessing()">
        <i class="fas fa-redo-alt"></i> Retry
      </button>
      <button class="btn btn--danger" (click)="deleteClicked()" *ngIf="!this.enableselect && !this.deleteMode">
        <i class="fa fa-times"></i> Delete
      </button>      
    </div>
    
    <div class="my-2" *ngIf="this.deleteMode">
      <p class="alert deleteConfirmText text-center">Are you sure?</p>
      <div class="d-flex justify-content-center flex-wrap gap-1.5">
        <button class="btn btn--sm btn--danger" (click)="confirmDeleteClicked()">Yes</button>
        <button class="btn btn--sm" (click)="cancelDeleteClicked()">No</button>
      </div>
    </div>
    <button *ngIf="enableselect" class="btn" (click)="selectClicked()">Select</button>
  </div>
</div>